import { currentVersion, useVersionStore } from "@/stores/VersionStore";

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

let lastCheckAt = 0;
let pendingCheck = null;
let pollingInterval = null;

function normalizeVersionInfo(versionInfo) {
  return {
    version: versionInfo && versionInfo.version ? versionInfo.version : "",
    commit: versionInfo && versionInfo.commit ? versionInfo.commit : "",
  };
}

function isDifferentVersion(versionInfo) {
  const remote = normalizeVersionInfo(versionInfo);
  const current = normalizeVersionInfo(currentVersion);

  return remote.version !== current.version || remote.commit !== current.commit;
}

function versionUrl() {
  const baseUrl = process.env.BASE_URL || "/";
  const path = baseUrl.endsWith("/") ? `${baseUrl}version.json` : `${baseUrl}/version.json`;

  return `${path}?t=${Date.now()}`;
}

export async function checkAppVersion(options = {}) {
  if (typeof window === "undefined" || typeof window.fetch !== "function") {
    return false;
  }

  const force = options.force === true;
  const now = Date.now();

  if (!force && now - lastCheckAt < CHECK_INTERVAL_MS) {
    return false;
  }

  if (pendingCheck) {
    return pendingCheck;
  }

  lastCheckAt = now;
  pendingCheck = window
    .fetch(versionUrl(), { cache: "no-store" })
    .then((response) => {
      if (!response.ok) {
        return false;
      }

      return response.json();
    })
    .then((versionInfo) => {
      if (!versionInfo || !isDifferentVersion(versionInfo)) {
        return false;
      }

      const versionStore = useVersionStore();
      versionStore.markUpdateAvailable(normalizeVersionInfo(versionInfo));

      return true;
    })
    .catch(() => false)
    .finally(() => {
      pendingCheck = null;
    });

  return pendingCheck;
}

export function startAppVersionPolling() {
  if (typeof window === "undefined" || pollingInterval) {
    return;
  }

  pollingInterval = window.setInterval(() => {
    checkAppVersion();
  }, CHECK_INTERVAL_MS);
}
